import { FilterOptionTypes, MsbCategories } from '@app/shared/enums';

export class MarketOperatorsFilter {
  name: string;
  marketOperators: Array<MarketOperators>;
  isVisible: boolean;

  constructor(_name: string, _mrketOperators: Array<MarketOperators>, _isVisible: boolean) {
    this.name = _name;
    this.marketOperators = _mrketOperators;
    this.isVisible = _isVisible;
  }

  isOn(): boolean {
    return this.marketOperators.every((x) => x.on);
  }
}

export interface MarketOperators {
  name: string;
  value: string;
  on: boolean;
  isVisible: boolean;
}

export interface FilterOptions {
  lineOfBusiness: string;
  msbCategory: string;
  msbid: MsbCategories | string;
  municipalityKey: string;
  name: string;
  type: FilterOptionTypes;
}

export interface MeterViewFilterOption {
  lineOfBusiness: string;
  filterValue: string;
  filterName: string;
  msbCategory: string;
}
